// extracted by mini-css-extract-plugin
module.exports = {"textOverflow":"TextOverFlow_textOverflow__Y3YE5","open":"TextOverFlow_open__4wkKE","expandRoot":"TextOverFlow_expandRoot__m8S7h","btnText":"TextOverFlow_btnText__A627q"};